angular
    .module("home.controller")
    .controller('changePasswordController', ['$rootScope', '$scope', 'userService','popupService', 
        function ($rootScope, $scope, userService,popupService) {
        //ChangePasswordFeature
        $scope.changePasswordCredentials = {
            identifier: '',
            password: '',
            newPassword: '',
            repeatPassword: '',
        };

        $scope.submitted = false;
        
        $scope.checkValidPassword = function () {
            $scope.isValidPassword = userService.isPasswordValid($scope.changePasswordCredentials.newPassword);
        };
        $scope.focus = function () {
            $('#password').focus();
        }
        //ChangePasswordFeature
        $scope.userChangePassword = function () {
            $scope.submitted = true;

            if (!this.changePasswordForm.$valid) {
                return;
            }

            userService.changePassword($scope.changePasswordCredentials).then(function (result) {
                if (result.Success) {
                    $rootScope.changePasswordPopupOn = false;
                    var otpions = {                       
                        okCallback: $rootScope.userLogout,
                        additionClass: 'popup-box-small'
                    };
                    popupService.showDialog("Your password has been updated successfully.", undefined, otpions);
                }
                else {
                    popupService.showDialog(result.ErrorMessage, undefined, {additionClass: 'popup-box-small'});
                }
            });
        };
    }]);